export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGOUT = 'LOGOUT';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';